export enum ImportEnum {
    IMPORT_IN_VIEW="IMPORT_IN_VIEW",
    IMPORT_NEW_TAB="IMPORT_NEW_TAB",
    NEW_TAB_CONNECTION="NEW_TAB_CONNECTION",
    MODEL_NEW_TAB="MODEL_NEW_TAB"
};